import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
export const getPaymentRecords = createAsyncThunk("paymentRecords/getPaymentRecords", async (data, thunkAPI) => {
  try {
    const resp = await axios.get(`${process.env.REACT_APP_BASE_URL}api/users/agent-payments-records/${data.id}`, {
      headers: {
        "Content-Type": "application/json",
      },
    });
    return resp.data?.data;
  } catch (error) {
    if (error.response) {
      return thunkAPI.rejectWithValue(error.response.data.message);
    } else {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
});
const initialState = {
  success: false,
  data: undefined,
  isLoading: false,
  errMsg: null,
};
const paymentRecords = createSlice({
  name: "paymentRecords",
  initialState,
  extraReducers: {
    [getPaymentRecords.pending]: (state) => {
      state.isLoading = true;
      state.errMsg = null;
      state.success = false;
    },
    [getPaymentRecords.fulfilled]: (state, action) => {
      state.isLoading = false;
      state.success = true;
      state.data = action.payload;
    },
    [getPaymentRecords.rejected]: (state, action) => {
      state.isLoading = false;
      state.success = false;
      state.errMsg = action.payload;
    },
  },
});
export default paymentRecords.reducer;
